var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('div',[_c('a',{staticClass:"back-btn-text",attrs:{"href":"javascript:;"},on:{"click":_vm.goBack}},[_c('a-icon',{attrs:{"type":"left"}}),_vm._v("返回 ")],1),_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }